import React, { useEffect, useRef } from "react";

import { Link } from "react-router-dom";
import ConfirmModal from "../../Components/ConfirmModal/ConfirmModal";
import ContentHeader from "../../Components/ContentHeader/ContentHeader";
import Loading from "../../Components/Loading/Loading";
import Table from "../../Components/Table/Table";
import Search from "../../Components/Search/Search";
import RrbDropdown from "../../Components/RRBDropdown/RrbDropdown";
import CustomToast from "../../Components/CustomToast/CustomToast";

function AuditsImagesUi({
  columns,
  data,
  onUpdate,
  loading,
  deleteAdminFn,
  onPageChange,
  tableQaury,
  totalRecords,
  setTableQaury,
  selectData,
  setFiltersId,
  setSelectData,
  filtersId,
  removeFilter,
  decodedToken,
  toast
}) {
  const totalPages = Math.ceil(totalRecords / tableQaury?.rowsPerPage);
  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <>
          {/* Content Wrapper. Contains page content */}
          <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <ContentHeader
              title={"Audits Form Images"}
              buttonName={"Add Audits Images"}
              buttonBoolean={true}
              pageName={""}
              linkPath={"/create-audit-images"}
            />

            {/* Main content */}
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                          {toast && (
                          <CustomToast
                            text={toast?.message}
                            type={toast?.type}
                          />
                        )}
                        {/* <Search setTableQaury={setTableQaury} tableQaury={tableQaury} placeHolder={"Search By Name"}/> */}
                        <Table
                          columns={columns}
                          data={data}
                          // loading={isLoading}
                          pagination={totalPages}
                          onPageChange={onPageChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </>
      )}

      <ConfirmModal
        confirmFn={deleteAdminFn}
        text={"Are you sure, you want to Delete?"}
        buttonText={"Delete"}
      />
    </div>
  );
}

export default AuditsImagesUi;
